
import axios from 'axios';



export const axios_jeresilie_sendLetter_withfile = async (data) => {
    return await axios.post(`/jeresilie/sendLetter_withfile/`, data, {
        headers: { 'Accept': 'application/json', 'Content-Type': 'multipart/form-data' }
    });
}

export const axios_jeresilie_sendLetter_nofile = async (data) => {
    return await axios.post(`/jeresilie/sendLetter_nofile/`, data, {
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    });
}




